import { createFileRoute } from "@tanstack/react-router";
import AdminUserNewPage from "@/pages/admin/users/new";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllUsers, userCanViewAllUsers } = useUsersPermissions();

  return (
    <AdminUserNewPage
      userCanEditAllUsers={userCanEditAllUsers}
      userCanViewAllUsers={userCanViewAllUsers}
    />
  );
}
